<h3 class="text-center text-light bg-secondary border">Pre-Pickup Verification Loads ({{filteredLoads.length}})</h3>
<kendo-grid #loadsGrid
            [data]="gridData"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            [sortable]="true"
            [filterable]="true"
            [resizable]="true"
            [autoSize]="true"
            [selectable]="false"
            [rowClass]="rowCallback"
            class="hideFilterOperators"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
            <div style="width:115px;">
                <!--<a [routerLink]="" (click)="rowSelected(load)"><i class="fas fa-angle-double-right fa-lg ml-3" [ngClass]="{'text text-primary': load.quoteOrderLineID==selectedLoad.quoteOrderLineID}"></i></a>-->
                <a (click)="sendEmail(load)" title="Email Tender"><i class="text-warning far fa-envelope fa-lg m-1"></i></a>
                <a (click)="viewTracking(load.quoteOrderID)" title="Track"><i class="text-primary far fa-calendar-alt fa-lg m-1"></i></a>
                <a (click)="linkMP(load.quoteOrderLineID)" title="Link MP"><i class="text-secondary fas fa-link fa-lg m-1"></i></a>
                <a (click)="editTender(load)" title="Modify Tender"><i class="text-success fas fa-edit fa-lg m-1"></i></a>
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Exclude" [hidden]="!isCSRManager">
        <ng-template kendoGridCellTemplate let-load>
            <div style="width:75px;">
                <button class="btn p-0 m-1" role="button" (click)="excludeMP(load)" title="Exclude MP" *ngIf="load.isExcludeMacropoint != true"><span class="text-danger font-weight-bold">MP</span></button>
                <button class="btn p-0 m-1" role="button" (click)="excludeVerification(load)" title="Exclude Verification" *ngIf="load.isExcludeVerification != true"><span class="text-warning font-weight-bold">Ver</span></button>
                <!--<a (click)="excludeVerification(load)" title="Exclude Verification"><i class="text-warning far fa-check-square fa-lg p-2"></i></a>-->
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="convoyStatus" title="Convoy"></kendo-grid-column>
    <kendo-grid-column field="bookedByCarrierRepName" title="CSR"></kendo-grid-column>
    <kendo-grid-column field="carrierName" title="Carrier">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                {{load.carrierName}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="carrierCode" title="Code">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                {{load.carrierCode}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="carrierContactName" title="Contact"></kendo-grid-column>
    <kendo-grid-column field="carrierContactPhone" title="Contact Phone">
        <ng-template kendoGridCellTemplate let-load>
            <a href="tel:{{load.carrierContactPhone}}">{{load.carrierContactPhone | phone}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City"></kendo-grid-column>
    <kendo-grid-column field="originState" title="O-St"></kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City"></kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-St"></kendo-grid-column>
    <kendo-grid-column field="isLoadVerified" title="P/U Confirmed">
        <ng-template kendoGridCellTemplate let-load>
            <a (click)="confirmCarrierPickup(load,true)"><i *ngIf="load.isLoadVerified!=true" class="far fa-square fa-lg text-secondary"></i></a>
            <a (click)="confirmCarrierPickup(load,false)"><i *ngIf="load.isLoadVerified==true" class="fas fa-check-square fa-lg text-primary"></i></a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="pickupCity" title="PPC City"></kendo-grid-column>
    <kendo-grid-column field="pickupState" title="PPC State"></kendo-grid-column>
    <kendo-grid-column field="pickupDepartDate" title="PPC Date">
        <ng-template kendoGridCellTemplate let-load>
            {{load.pickupDepartDate == '' ? '' : load.pickupDepartDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="driverName" title="Driver"></kendo-grid-column>
    <kendo-grid-column field="driverCell" title="Driver Phone">
        <ng-template kendoGridCellTemplate let-load>
            <a href="tel:{{load.driverCell == '' ? load.driverPhone : load.driverCell}}">{{load.driverCell == '' ? load.driverPhone : load.driverCell | phone}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="dispatcherName" title="Dispatcher"></kendo-grid-column>
    <kendo-grid-column field="isAccepted" title="Accepted">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isAccepted!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isAccepted==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trailerNumber" title="Trailer #"></kendo-grid-column>
    <kendo-grid-column field="truckNumber" title="Truck #"></kendo-grid-column>
    <kendo-grid-column field="hasInfo" title="Has Info">
        <ng-template kendoGridCellTemplate let-load>
            <span [ngClass]="load.hasInfoClass">{{load.hasInfo}}</span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="miles" title="Miles"></kendo-grid-column>
    <kendo-grid-column field="mpSetup" title="MP Setup">
        <ng-template kendoGridCellTemplate let-load>
            <span [ngClass]="load.mpSetupClass">{{load.mpSetup}}</span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority"></kendo-grid-column>
    <kendo-grid-column title="Tags">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                <tagtype-tag [tag]="tag"></tagtype-tag>
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="customerCode" title="Bill To">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/customer-detail', load.customerCode]">
                {{load.customerCode}} - {{load.customerName}}
            </a>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
